import styled from 'styled-components';
import { Box } from '@comeon/ui';

const NotificationDot = styled.button`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${props =>
		props.active ? 'rgb(var(--notification-popup-dot-active))' : 'rgb(var(--notification-popup-dot))'};
`;

const Wrapper = styled(Box).attrs({ p: 6 })`
	display: flex;
	justify-content: center;
	& > button {
		margin-right: 8px;
	}
`;

const MyNotificationsNavigationDots = ({ length = 0, activeIndex = 0 }) => {
	const navigationDotsList = Array(length)
		.fill(1)
		.map((value, index) => index * value);

	return (
		<Wrapper data-at="navigation-dots">
			{navigationDotsList.map(i => (
				<NotificationDot key={i} active={i === activeIndex} data-at="my-notification-navigation-dots-dot" />
			))}
		</Wrapper>
	);
};

export default MyNotificationsNavigationDots;
